import script from "./wxGroupContentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./wxGroupContentEdit.vue?vue&type=script&setup=true&lang=js"

import "./wxGroupContentEdit.vue?vue&type=style&index=0&id=0f28252f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f28252f"]])

export default __exports__